import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL || "";

export const VOICE_OPTIONS = [
  { id: "male", label: "Male" },
  { id: "female", label: "Female" },
];

export const SPEED_OPTIONS = [0.75, 1, 1.25, 1.5, 2];

// Fetch narrated audio for a piece of text and return a playable object URL.
// `lang` (en|pt|es) keeps narration aligned with the active interface language.
// Markdown links `[title](url)` are reduced to their visible title before being
// sent to `/api/voice/tts`, so the URL is never spoken aloud. Applies to both
// internal and external links. Stored message text is unchanged.
export async function fetchNarration(text, voice = "male", lang = "en") {
  const spoken = (text || "").replace(/\[([^\]]+)\]\(([^)]+)\)/g, "$1");
  const response = await axios.post(
    `${backendUrl}/api/voice/tts`,
    { text: spoken, voice, lang },
    { responseType: "blob" }
  );
  return URL.createObjectURL(response.data);
}

// Transcribe a recorded audio blob into text via Whisper.
// `lang` hints the recogniser so speech is understood in the chosen language.
export async function transcribeAudio(blob, lang = "en") {
  const form = new FormData();
  const type = (blob.type || "").toLowerCase();
  let ext = "webm";
  if (type.includes("mp4") || type.includes("m4a")) ext = "mp4";
  else if (type.includes("mpeg") || type.includes("mp3")) ext = "mp3";
  else if (type.includes("ogg")) ext = "ogg";
  else if (type.includes("wav")) ext = "wav";
  form.append("file", blob, `recording.${ext}`);
  if (lang) form.append("language", lang);
  const response = await axios.post(`${backendUrl}/api/voice/stt`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return (response.data && response.data.text) || "";
}
